import React from 'react';
import { Row, Col, Card, Space, Progress } from 'antd';
import {
    UserOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined
} from '@ant-design/icons';

const styles = {
    subText: {
        fontSize: 12,
        color: 'var(--gh-text-secondary, #607D8B)'
    },
    statValue: {
        fontSize: 18,
        color: 'var(--gh-text-primary, #263238)',
        fontWeight: 500,
        minHeight: 20
    }
};

const CampaignStatsCards = ({ stats, showProgress, isLive }) => {
    const { total = 0, delivered = 0, failed = 0, pending = 0 } = stats;
    const processed = delivered + failed;
    const percent = total > 0 ? Math.round((processed / total) * 100) : 0;

    return (
        <>
            {showProgress && total > 0 && (
                <div style={{ marginBottom: 8 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--gh-text-primary, #263238)' }}>
                            {processed} of {total} messages processed
                        </span>
                        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--gh-primary-active, #2E7D32)' }}>
                            {percent}%
                        </span>
                    </div>
                    <Progress
                        percent={percent}
                        showInfo={false}
                        strokeColor={{
                            '0%': '#66BB6A',
                            '100%': '#2E7D32'
                        }}
                        size="small"
                    />
                </div>
            )}

            <Row gutter={[6, 6]} style={{ marginBottom: 6 }}>
                <Col xs={12} sm={6}>
                    <Card size="small" bodyStyle={{ padding: '6px 8px' }} style={{ borderRadius: 8 }}>
                        <Space size={8}>
                            <UserOutlined style={{ color: 'var(--gh-text-secondary, #607D8B)' }} />
                            <div>
                                <div style={styles.subText}>Contacts</div>
                                <div style={styles.statValue}>{total}</div>
                            </div>
                        </Space>
                    </Card>
                </Col>
                <Col xs={12} sm={6}>
                    <Card size="small" bodyStyle={{ padding: '6px 8px' }} style={{ borderRadius: 8, background: 'var(--gh-primary-tint, #E8F5E9)' }}>
                        <Space size={8}>
                            <CheckCircleOutlined style={{ color: 'var(--gh-primary-active, #2E7D32)' }} />
                            <div>
                                <div style={styles.subText}>Msg. Delivered</div>
                                <div style={{ ...styles.statValue, color: 'var(--gh-primary-active, #2E7D32)' }}>{delivered}</div>
                            </div>
                        </Space>
                    </Card>
                </Col>
                <Col xs={12} sm={6}>
                    <Card size="small" bodyStyle={{ padding: '6px 8px' }} style={{ borderRadius: 8, background: 'rgba(255,77,79,0.08)' }}>
                        <Space size={8}>
                            <CloseCircleOutlined style={{ color: 'var(--gh-danger, #FF4D4F)' }} />
                            <div>
                                <div style={styles.subText}>Msg. Failed</div>
                                <div style={{ ...styles.statValue, color: 'var(--gh-danger, #FF4D4F)' }}>{failed}</div>
                            </div>
                        </Space>
                    </Card>
                </Col>
                <Col xs={12} sm={6}>
                    <Card size="small" bodyStyle={{ padding: '6px 8px' }} style={{ borderRadius: 8 }}>
                        <Space size={8}>
                            <ClockCircleOutlined style={{ color: 'var(--gh-warning, #FFB300)' }} />
                            <div>
                                <div style={styles.subText}>Pending</div>
                                <div style={{
                                    ...styles.statValue,
                                    color: 'var(--gh-warning, #FFB300)',
                                    ...(isLive && pending > 0 ? { animation: 'pulse 2s ease-in-out infinite' } : {})
                                }}>
                                    {pending}
                                </div>
                            </div>
                        </Space>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default CampaignStatsCards;
